module.exports = __webpack_public_path__ + "static/media/Bauchi State Government.fda447eb.png";